import { SxProps, Theme } from "@mui/material";
import { CSSProperties } from "react";

export const headerContainerStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: 4,
  mb: 2,
  justifyContent: "space-between",
};

export const headerTextStyles: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  mb: 3,
  fontWeight: 600,
  color: theme.palette.modalColors.colorLable,
});

export const controlContainerStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const formControlStyles: SxProps<Theme> = {
  width: { xs: "100%" },
};

export const selectStyles: SxProps<Theme> = (theme) => ({
  borderRadius: "8px",
  color: theme.palette.modalColors.colorLable,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.modalColors.separatorColor,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.modalColors.separatorColor,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.modalColors.separatorColor,
  },
  "& .MuiSvgIcon-root": {
    color: "#00BFA6",
  },
});

export const legendContainerStyles: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1.5,
  mb: 2,
};

export const legendItemStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const legendCircleGradient: SxProps<Theme> = {
  width: 10,
  height: 10,
  borderRadius: "50%",
  background: "linear-gradient(180deg, #00BFA6 0%, #4C56D3 100%)",
};

export const legendCircleSolid: SxProps<Theme> = {
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: "#6FCF97",
};

export const legendTextStyles: SxProps<Theme> = (theme) => ({
  fontSize: "14px",
  color: "#828282",
});

export const chartContainerStyles: SxProps<Theme> = {
  width: "100%",
  height: 300,
};

export const noDataBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
};

export const chartMargin = { top: 20, right: 0, left: -45, bottom: 20 };

export const adjustedChartMargin = {
  top: 20,
  right: 20,
  left: -15,
  bottom: 30,
};

export const responsiveChartContainerStyles: SxProps<Theme> = {
  height: 285,
  width: "100%",
  overflow: "hidden",
  position: "relative",
  px: 1,
  boxSizing: "border-box",
  maxWidth: "100%",
};

export const xAxisTickStyles = {
  fontSize: 12,
  width: 50,
};

export const yAxisStyles = {
  tickLine: false,
  axisLine: false,
  orientation: "left" as const,
  tickMargin: -20,
  width: 25,
};

export const tooltipContentStyles: CSSProperties = {
  borderRadius: "8px",
  borderColor: "#E0E0E0",
};

export const extendedTooltipContentStyles: CSSProperties = {
  ...tooltipContentStyles,
  overflow: "hidden",
  padding: "5px",
  fontSize: "12px",
};

export const tooltipWrapperStyles: CSSProperties = {
  zIndex: 100,
  pointerEvents: "none",
  width: "auto",
  maxWidth: "90%",
};
